// extracted by mini-css-extract-plugin
export var errorIcon = "_kw-1";
export var nameLogo = "_kw-0";